import { useTranslation } from 'react-i18next'

import { CheckCircleIcon, XCircleIcon } from '@phosphor-icons/react'

import { IconButton, LineItem } from '@reveni-io/reveni-ui'

import { amendSelectionStatuses } from '../constants'
import * as Styles from './styles'

const AmendRejectedLineItem = ({ lineItem, isAmended, onSelect }) => {
  const { t } = useTranslation()

  const handleAccept = () => onSelect(amendSelectionStatuses.amended)

  const handleReject = () => onSelect(amendSelectionStatuses.rejected)

  return (
    <Styles.Container amended={isAmended}>
      <Styles.IconsContainer>
        <div>
          <IconButton
            variant={isAmended ? 'outlined' : 'contained'}
            color="danger"
            hoverText={t('Rechazar')}
            onClick={handleReject}
            icon={<XCircleIcon size={20} />}
          />
        </div>
        <div>
          <IconButton
            variant={isAmended ? 'contained' : 'outlined'}
            color="success"
            hoverText={t('Aceptar')}
            onClick={handleAccept}
            icon={<CheckCircleIcon size={20} />}
          />
        </div>
      </Styles.IconsContainer>
      <Styles.LineItemsContainer>
        <LineItem item={{ ...lineItem, reject_reason_text: null, status: null }} />
        {lineItem?.bundleItems?.map(item => (
          <LineItem key={item.id} item={{ ...item, reject_reason_text: null, status: null }} />
        ))}
      </Styles.LineItemsContainer>
    </Styles.Container>
  )
}

export default AmendRejectedLineItem
